import React from 'react';
import { Container, Row, Col, Image, ListGroup } from 'react-bootstrap';
import Blog3 from '../Components/img/Blog3.jpg'; // Using the image from the blog

const DealingWithAnxiety = () => {
  return (
    <Container className="py-5">
      <Row className="align-items-center">
        <Col md={6}>
          <Image src={Blog3} alt="Dealing with Anxiety" fluid className="rounded shadow" />
        </Col>
        <Col md={6}>
          <h2 className="text-dark">Dealing with Anxiety: A Guide</h2>
          <p className="text-muted">
            Anxiety is a common but challenging experience that affects mental and emotional well-being. 
            Learning to manage anxiety effectively can lead to a **calmer, more balanced life** and improve 
            daily productivity, relationships, and overall happiness.
          </p>
          <p className="text-muted">
            Recognizing anxiety triggers and adopting **healthy coping strategies** are essential in 
            overcoming excessive worry and stress. With the right techniques, you can regain control 
            over your thoughts and emotions.
          </p>

          <h5 className="text-dark mt-4">Effective Ways to Manage Anxiety:</h5>
          <ListGroup variant="flush" className="mt-3">
            <ListGroup.Item>✅ <strong>Practice Deep Breathing:</strong> Helps lower stress levels and brings instant relief.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Engage in Regular Exercise:</strong> Physical activity releases endorphins that improve mood.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Maintain a Healthy Diet:</strong> Proper nutrition supports mental clarity and emotional stability.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Get Quality Sleep:</strong> A well-rested mind is more resilient to anxiety.</ListGroup.Item>
            <ListGroup.Item>✅ <strong>Seek Support:</strong> Talking to a therapist or loved one can provide guidance and relief.</ListGroup.Item>
          </ListGroup>

          <p className="text-muted mt-3">
            Taking small but consistent steps can help you **build emotional resilience** and reduce daily anxiety. 
            Stay informed with expert insights and **proven relaxation techniques** to lead a more peaceful life.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default DealingWithAnxiety;
